import { Outlet, useLocation } from 'react-router-dom'
import React, {useEffect} from 'react';
import { Modal } from 'react-bootstrap';
import { NavBar } from '@commons/Componentes/Navbars/Navbar';
import { SideBar } from '@commons/Componentes/Sidebar/SideBar';
import { useTheme,useAuthentication } from "@commons/Hooks";
import {getComponentWithLoading} from "../../Commons/Scripts/Utils";
import { ConfiguracionInicialProvider } from '@configuracionInicial/Providers/ConfiguracionInicialProvider';
import { ConfiguracionInicialGate } from '@configuracionInicial/Components/ConfiguracionInicialGate';
import { ConfiguracionInicialRecordatorio } from '@configuracionInicial/Components/ConfiguracionInicialRecordatorio';
import { useConfiguracionInicial } from '@configuracionInicial/Hooks/useConfiguracionInicial';

function ConfiguracionInicialRouteOverlay ({ esWizardConfiguracionInicial }) {
    const { bienvenidaVisible, consultandoEstado } = useConfiguracionInicial();

    // En el primer acceso la bienvenida ocupa el lugar del recorrido. El wizard
    // se monta únicamente después de que el usuario decide comenzarlo.
    if (!esWizardConfiguracionInicial || consultandoEstado || bienvenidaVisible) return null;

    return (
        <Modal
            id="ci-configuracion-inicial-overlay"
            show
            centered
            backdrop="static"
            keyboard={false}
            enforceFocus
            restoreFocus
            className="ci-wizard-route-modal"
            backdropClassName="ci-wizard-route-backdrop"
            dialogClassName="ci-wizard-route-dialog"
            contentClassName="ci-wizard-route-content"
            aria-label="Asistente de configuración inicial de Citrus ERP"
        >
            <div id="ci-configuracion-inicial-dialog" className="bootstrapiso ci-wizard-route">
                <Outlet />
            </div>
        </Modal>
    );
}

function Layout ({showLoading, hideLoading}){
    const {theme} = useTheme();
    const {usuario} = useAuthentication();
    const location = useLocation();
    const esWizardConfiguracionInicial = location.pathname.replace(/\/+$/, '').toLowerCase() === '/app/configuracioninicial';
    useEffect(() => {
        const navbar = document.querySelector("#NavBar");
        document.addEventListener("click", function (event) {
            if (!navbar.contains(event.target) ) {
                let DropdownTrigger = navbar.querySelector('.show.dropdown.nav-item')
                if(DropdownTrigger){
                    DropdownTrigger.click()
                }
            }
        });
    }, []);

    return (
      <ConfiguracionInicialProvider esRutaWizard={esWizardConfiguracionInicial}>
        <div
            className={`bootstrapiso ci-wizard-route-background${esWizardConfiguracionInicial ? ' ci-wizard-route-background--obscured' : ''}`}
            inert={esWizardConfiguracionInicial ? '' : undefined}
            style={{ opacity: usuario ? 1 : 0 }}
        >
            <div className="wrapper">
                    <div id="sidebar" className="sidebar" style={{
                        backgroundImage: `linear-gradient(${theme?.color1},${theme?.color2} 150%)`,
                        zIndex: '900002'
                    }}>
                        <SideBar />
                    </div>
                <div className="main-panel">
                    <div id='navPanel' style={{
                        position: 'sticky',
                        top: '0',
                        height: '70px',
                        zIndex: '900001'
                    }}>
                        <div className='bootstrapiso' style={{height:"inherit"}}>
                            <div id="NavBar" className="navbar navbar-expand-lg navbar-light bootstrapiso" style={{
                                borderBottom: '1px solid rgba(0, 0, 0, .1)',
                                maxHeight: '71px',
                                minHeight: '71px',
                                paddingLeft: '0px',
                                paddingRight: '0px',
                            }}>
                                <NavBar />
                            </div>
                            {usuario?.Compania.Configuracion.Mensaje && (
                                <marquee style={{
                                    color: usuario.Compania.Configuracion.ColorMensaje ? `#${usuario.Compania.Configuracion.ColorMensaje}` : '#FF0000',
                                    zIndex: '900014',
                                    top: 50,
                                    position: 'absolute'
                                }} id="mqId" behavior="scroll" direction="left">{usuario.Compania.Configuracion.Mensaje}</marquee>
                            )}
                        </div>
                    </div>
                        {!esWizardConfiguracionInicial && <ConfiguracionInicialRecordatorio />}
                        {!esWizardConfiguracionInicial && <Outlet />}
                </div>
            </div>
        </div>
        <ConfiguracionInicialRouteOverlay esWizardConfiguracionInicial={esWizardConfiguracionInicial} />
        <ConfiguracionInicialGate />
      </ConfiguracionInicialProvider>
    )
}

export const App = React.memo(getComponentWithLoading(Layout));
